var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 9.999a3.2 3.2 0 0 1-2.354-.98 3.2 3.2 0 0 1-.98-2.354q0-1.374.98-2.354A3.2 3.2 0 0 1 10 3.332a3.2 3.2 0 0 1 2.354.98 3.2 3.2 0 0 1 .979 2.353 3.2 3.2 0 0 1-.98 2.355A3.2 3.2 0 0 1 10 9.999m-6.667 6.666v-2.333q0-.708.365-1.302a2.43 2.43 0 0 1 .968-.906 12.4 12.4 0 0 1 2.625-.97A11.5 11.5 0 0 1 10 10.833q1.375 0 2.708.323a12.4 12.4 0 0 1 2.625.969q.605.312.969.906t.364 1.302v2.333z"
})));
export default SvgUser;